import styled from "styled-components";
export const PickUpLocationWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
